import React from 'react';

import { headShotInfoProps } from './propTypes';

import Headshot from '@nhl/nhl-react-ui/lib/Headshot';
import headshotTypes from '@nhl/nhl-react-ui/lib/Headshot/headshotTypes';
import PlayerLink from '@nhl/nhl-react-ui/lib/PlayerLink';

import './styles.scss';

const HeadshotInfo = ({ player, team, size, season, baseInfoComponent = '', dataComponent = '' }) => {
    return (
        <PlayerLink className="headshot-info-player" player={player || {}}>
            <Headshot
                headshotId={player?.id}
                headshotClass="player-headshot"
                type={player?.position?.positionCode === 'G' ? headshotTypes.GOALIE : headshotTypes.SKATER}
                team={ team }
                league={ team?.league ? team.league.abbreviation.toLowerCase() : undefined }
                size={ size }
                season={ season }
                forceSilhouette={!player || !team}
            />
            { baseInfoComponent }
            { dataComponent }
        </PlayerLink>
    );
};

HeadshotInfo.propTypes = headShotInfoProps;

export default HeadshotInfo;
